export default class ModuleInfo {
    /**
     * @param {string} area - Area containing module
     * @param {string} name - Modules of same area combined
     * @param {boolean} icon - small icon shown before name
     * @param {string} url - Url of the module
     */
    constructor({
                    area = undefined,
                    name = undefined,
                    icon = false,
                    url = undefined
    }) {
        this.area = area
        this.name = name;
        this.icon = icon;
        this.url = url;
    }
};